'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
require('../../../../../../aviary-core/dist/cjs/index.cjs');
var React = require('react');
var Button_web = require('../../../atoms/Button/Button.web.cjs');
var CircularIcon_web = require('../../../atoms/CircularIcon/CircularIcon.web.cjs');
var Skeleton_web = require('../../../atoms/Skeleton/Skeleton.web.cjs');
var reactFontawesome = require('../../../../react-fontawesome/react-fontawesome.cjs');
var Media_web_styles = require('./Media.web.styles.cjs');
var index$1 = require('../../../../../../../_virtual/index.cjs');

/**
 * Description added in ProductCard.web.tsx
 */ const Media = ({ type = "product", image, icon = index.faStethoscope, size = "medium", iconBackgroundColor = "forest", onQuickViewClick, alt, disableLazyLoading, isLoading = false })=>{
    const [hasLoadError, setHasLoadError] = React.useState(false);
    const handleImageError = (e)=>{
        e.stopPropagation();
        setHasLoadError(true);
    };
    const renderMediaType = ()=>{
        if (type === "product") {
            const product = /*#__PURE__*/ jsxRuntime.jsx("img", {
                src: hasLoadError ? index$1.__exports.FallbackProductImage : image,
                alt: alt,
                title: alt,
                css: [
                    Media_web_styles.productImage.base,
                    Media_web_styles.productImage[size]
                ],
                onError: handleImageError,
                loading: disableLazyLoading ? undefined : "lazy"
            });
            const productSkeleton = /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
                height: Media_web_styles.PRODUCT_IMAGE_SIZES[size],
                width: Media_web_styles.PRODUCT_IMAGE_SIZES[size]
            });
            return /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: Media_web_styles.productWrapper,
                children: isLoading ? productSkeleton : product
            });
        }
        if (type === "resource") {
            return isLoading ? /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
                isFullWidth: true,
                height: 120
            }) : /*#__PURE__*/ jsxRuntime.jsx("img", {
                src: image,
                alt: alt,
                css: Media_web_styles.resourceImage
            });
        }
        return /*#__PURE__*/ jsxRuntime.jsx(CircularIcon_web.CircularIcon, {
            icon: icon,
            size: "medium",
            backgroundColor: iconBackgroundColor,
            isLoading: isLoading
        });
    };
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: Media_web_styles.mediaWrapper,
        children: [
            renderMediaType(),
            onQuickViewClick && !isLoading && /*#__PURE__*/ jsxRuntime.jsxs(Button_web.Button, {
                customCss: Media_web_styles.quickViewButton,
                className: "visible-on-card-hover",
                onClick: onQuickViewClick,
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
                        icon: index.faEye,
                        css: Media_web_styles.quickViewIcon
                    }),
                    "Quick view"
                ]
            })
        ]
    });
};

exports.Media = Media;
//# sourceMappingURL=Media.web.cjs.map
